import React from 'react';
import { createPortal } from 'react-dom';
import { C, FONT_UI } from '../../constants/design-tokens';
import { TabBtn } from '../../shared/ui/tab-btn';
import { PanelId } from '../../shared/hooks/use-panels';
import { useFlyoutPosition } from '../../shared/hooks/use-flyout-position';

type FlyoutItem = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
};

type FlyoutTabProps = {
  panelId: PanelId;
  label: string;
  icon: React.ReactNode;
  items: FlyoutItem[];
};

export const FlyoutTab: React.FC<FlyoutTabProps> = ({ panelId, label, icon, items }) => {
  const { open, triggerRef, pos, toggle, close } = useFlyoutPosition(panelId);

  return (
    <div ref={triggerRef} data-panel-id={panelId} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <TabBtn onClick={toggle} label={label} icon={icon} active={open} />

      {open &&
        pos &&
        createPortal(
          <div
            data-panel-id={panelId}
            style={{
              position: 'fixed',
              top: pos.top,
              right: pos.right,
              display: 'flex',
              gap: 4,
              padding: 6,
              background: C.bg,
              border: `1px solid ${C.border}`,
              borderRadius: 12,
              boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
              fontFamily: FONT_UI,
              zIndex: 100
            }}
          >
            {items.map(item => (
              <TabBtn
                key={item.label}
                onClick={() => {
                  item.onClick();
                  close();
                }}
                label={item.label}
                icon={item.icon}
              />
            ))}
          </div>,
          document.body
        )}
    </div>
  );
};
